import React from 'react'

const Divider = () => {
  return (
    <div className='border-black border-opacity-10 border-b m-4 dark:border-white dark:border-opacity-10'>

    </div>
  )
}

export default Divider